import { render } from "./turnCreate.vue?vue&type=template&id=42d39084"
import script from "./turnCreate.vue?vue&type=script&lang=js"
export * from "./turnCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__